(() => {
	
	const config = {
		productHandle: window.ALMA_PRODUCT_HANDLE,
		widgetDiv: window.ALMA_WIDGET_DIV_NAME,
		pageType: window.ALMA_PAGE_TYPE,
		initCartAmount: window.ALMA_INIT_CART_AMOUNT,
		displayIfNotEligible: window.ALMA_DISPLAY_WIDGET_NOT_ELIGIBLE,
		feePlans: window.ALMA_FEE_PLANS,
		cdnUrl: window.ALMA_WIDGET_CDN_URL,
		merchantId: window.ALMA_MERCHANT_ID,
		updateQuantityWidget: window.ALMA_UPDATE_QUANTITY_WIDGET,
		almaProductData: window.ALMA_PRODUCT_DATA,
		monochrome: window.ALMA_WIDGET_MONOCHROME,
		locale: window.ALMA_LOCALE || Shopify.locale,
	};

	const quantityInput = document.querySelector('input[name="quantity"]');

	const designMode = window.Shopify.designMode;
	let almaWidget = null;
	let lastWidgetConfig = null;
	let lastWidgetContainer = null;

	if (Shopify.currency.active !== "EUR") return;

	async function getVariantId() {
		try {
			if (window.Shopify?.currentVariant?.id) {
				return window.Shopify.currentVariant.id;
			}

			const urlParams = new URLSearchParams(window.location.search);
			const variantFromUrl = urlParams.get("variant");
			if (variantFromUrl) return variantFromUrl;

			const productData = config.almaProductData;
			if (!productData) return null;

			const defaultVariant =
				productData.variants.find((v) => v.available) ||
				productData.variants[0];
			return defaultVariant?.id;
		} catch (error) {
			console.error("Failed to get variant ID:", error);
			return null;
		}
	}

	async function getProductPrice(variantId) {
		if (!variantId) return 0;
		try {
			const product = config.almaProductData;
			if (!product) return 0;

			const variant = product.variants.find(
				(v) => v.id === Number.parseInt(variantId),
			);
			return variant?.price || 0;
		} catch (error) {
			console.error("Failed to get product price:", error);
			return 0;
		}
	}

	function loadWidget(productPrice = 0) {
		const plans = getPlans();
		if (plans.length > 0 && almaWidget) {
			const options = {
				container: config.widgetDiv,
				locale: config.locale,
				purchaseAmount: productPrice,
				hideIfNotEligible: !config.displayIfNotEligible,
				plans: plans,
				monochrome: config.monochrome,
			};
			const container = document.querySelector(config.widgetDiv);
			const signature = JSON.stringify(options);
			if (
				container &&
				container === lastWidgetContainer &&
				container.childElementCount > 0 &&
				signature === lastWidgetConfig
			) return;
			almaWidget.add(Alma.Widgets.PaymentPlans, options);
			lastWidgetConfig = signature;
			lastWidgetContainer = container;
		}
	}

	function getPlans() {
		const plans = [];
		try {
			const configPlans = JSON.parse(config.feePlans);

			for (const key in configPlans) {
				if (configPlans[key].is_enabled === "True") {
					const match = key.match(/_(\d+)_(\d+)_(\d+)$/);
					if (!match) continue;

					const [, installment, deferredDays, deferredMonth] = match;
					plans.push({
						installmentsCount: Number.parseInt(installment),
						deferredDays: Number.parseInt(deferredDays),
						deferredMonth: Number.parseInt(deferredMonth),
						minAmount: configPlans[key].min_amount,
						maxAmount: configPlans[key].max_amount,
					});
				}
			}
		} catch (error) {
			console.error("Failed to parse Alma plans:", error);
		}
		return plans;
	}

	function initWidget() {
		almaWidget = Alma.Widgets.initialize(config.merchantId, Alma.ApiMode.LIVE);
	}

	async function updateWidgetPrice() {
		if (config.pageType.startsWith("product")) {
			const variantId = await getVariantId();
			const productPrice = await getProductPrice(variantId);
			const quantity = Number.parseInt(quantityInput?.value) || 1;
			const price = productPrice * quantity;
			loadWidget(price);
		} else {
			loadWidget(config.initCartAmount);
		}
	}

	function loadScript() {
		const script = document.createElement("script");
		script.type = "text/javascript";
		script.onload = async () => {
			initWidget();
			if (designMode) {
				loadWidget(25600);
			} else {
				await updateWidgetPrice();
			}
		};
		script.src = config.cdnUrl;
		document.head.appendChild(script);
	}

	function isShopifyCartChangeURL(input) {
		let urlString = "";

		if (typeof input === "string") {
			urlString = input;
		} else if (input instanceof Request) {
			urlString = input.url;
		} else if (input instanceof URL) {
			urlString = input.href;
		} else {
			return false;
		}

		return urlString.includes("/cart/change");
	}

	function setupObservers() {

		let lastUrl = location.href;
		new MutationObserver(async () => {
			const currentUrl = location.href;
			if (currentUrl !== lastUrl) {
				lastUrl = currentUrl;
				await updateWidgetPrice();
			}
		}).observe(document, { subtree: true, childList: true });

		if (config.pageType.startsWith("cart")) {
			const originalFetch = window.fetch;
			window.fetch = function (...args) {
				return originalFetch.apply(this, args).then((response) => {
					if (isShopifyCartChangeURL(args[0])) {
						response
							.clone()
							.json()
							.then((cart) => {
								loadWidget(cart.total_price);
							});
					}
					return response;
				});
			};
		}

		if (config.updateQuantityWidget && quantityInput) {
			quantityInput.addEventListener("change", async () => {
				await updateWidgetPrice();
			});
		}
	}

	loadScript();
	setupObservers();
})();
